import { render } from "./index.vue?vue&type=template&id=370975e8&scoped=true"
const script = {}

import "./index.vue?vue&type=style&index=0&id=370975e8&lang=less&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-370975e8"]])

export default __exports__